/**
 * Initializes animations and interactions for the hero5 module.
 *
 * @function hero1
 * @returns {void}
 */
function hero5() {
  const section = document.querySelector('[data-module="hero5"]');
  if (section) {
    section.classList.add('is-active');
  }

  const menu = document.querySelector('[data-menu]');
  const menuTitle = document.querySelector('[data-menu-title]');
  if (menuTitle && menu) {
    menuTitle.addEventListener('click', () => menu.classList.toggle('is-active'));
  }
}

export default hero5;
